export default {
  primary: '#64B5F6',
  secondary: '#0277BD',
  accent: '#82B1FF',
  error: '#FF5252',
  dashboardError: '#E02D38',
  dashboardSuccess: '#199473',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FBC02D',
};



// WEBPACK FOOTER //
// ./src/env/ThemeConfig.js